import React from 'react'
import { useTranslation } from 'react-i18next'
import { ReactComponent as CheckIcon } from 'assets/icons/check-copy-10.svg'
import { ReactComponent as QuestionMarkIcon } from 'assets/icons/question-mark.svg'
import moment from 'moment'
import styles from 'components/Order/OrderDetails/HistoryTabs/Tabs/Tabs.module.css'
import {
  isLoaded,
  isUnloaded
} from 'components/Order/OrderDetails/DeliveryPointCargoApproveForm/deliveryPointCargoHelper'
import RowsCollapse from 'components/Order/OrderDetails/HistoryTabs/Tabs/RowsCollapse'
import classNames from 'classnames'
import { findNumberOfIntermediatePointAtPosition } from 'components/Order/utils'
import { useHistory } from 'react-router-dom'
import { DateTimeWithZoneCell } from 'components/Shared/DateTimeWithZoneCell/DateTimeWithZoneCell'
import {Link} from "components/Shared/Link";

export function OrderHistory ({
  order,
  actions,
  isEditable,
  onOrderStatusChangeEdit,
  onCargoApproveRejectClicked,
  onDeliveryPointCargoShow
}) {
  const { t } = useTranslation()
  const history = useHistory()

  const getOrderStatusChangeActionLabel = (action) => {
    let label = t(`order.details.history.actions.orderStatus.${action.status}`, {
      deliveryPointNumber: action.deliveryPointPosition,
      intermediatePointNumber: action.intermediatePointPosition !== null
        ? findNumberOfIntermediatePointAtPosition(order, action.intermediatePointPosition)
        : undefined
    })
    if (isLoaded(action) || isUnloaded(action)) {
      if (action.deliveryPointCargo?.quantity && action.deliveryPointCargo?.weight) {
        label = `${label}: 
        ${action.deliveryPointCargo.quantity} × 
        ${t(`order.details.history.actions.wrappingTypes.${action.deliveryPointCargo.wrappingType}`)}, 
        ${action.deliveryPointCargo.weight} kg`
      }
      if (action.approved === null) {
        label = `${label} (${t(`order.details.history.actions.waitingForApproval`)})`
      }
    }
    return label
  }

  const getDeliveryPointCargoStatusChangeActionLabel = (action) => {
    return `${t(`order.details.history.actions.deliveryPointCargo.${action.status}`)} ${action.deliveryPointPosition} 
    ${action.approved ? t(`order.details.history.actions.deliveryPointCargo.approvedBy`) :
      t(`order.details.history.actions.deliveryPointCargo.rejectedBy`)}: ${action.userFirstName} ${action.userLastName}`
  }

  const handleActionType = (param) => {
    switch (param.actionType) {
      case 'EDIT': {
        return `${t(
          'order.details.history.actions.edited')}: ${param.actionExecutor.firstName} ${param.actionExecutor.lastName}`
      }
      case 'DRIVER_STATUS_CHANGE': {
        return `${t('order.details.history.actions.driverStatus.title')}: ${t(
          `order.details.history.actions.driverStatus.${param.status}`)}`
      }
      case 'ORDER_STATUS_CHANGE': {
        return getOrderStatusChangeActionLabel(param)
      }
      case 'ATTACHMENT_REJECTED': {
        return `${t(
          'order.details.history.actions.attachmentRejected', { user: `${param.actionExecutor.firstName} ${param.actionExecutor.lastName}` })}`
      }
      case 'DELIVERY_POINT_CARGO_STATUS_CHANGE': {
        return getDeliveryPointCargoStatusChangeActionLabel(param)
      }
      default: {
        return t('order.details.history.actions.error')
      }
    }
  }

  const isActionRowWaitingForDecision = (row) => row.actionType === 'ORDER_STATUS_CHANGE' &&
    row.approved === null && (isLoaded(row) || isUnloaded(row))

  const showOrderEditHistory = (row) => {
    history.push('/orders/details/' + order.id + '/editHistory/' + row.id)
  }

  return (<RowsCollapse itemsCount={actions.length}>
      <div className={styles.historyItems}>
        {actions.map((row, index) => {
          const isActionWaitingForDecision = isActionRowWaitingForDecision(row)
          return (
            <div className={classNames(styles.historyItem, styles.action)} key={row.id}>
              <div className={styles.historyItemCell}>
                {isActionWaitingForDecision ? <QuestionMarkIcon/> : <CheckIcon/>}
              </div>
              <div className={styles.historyItemCell}>
                {moment(row.creationDateTime).format('DD.MM.YYYY')}
              </div>
              <DateTimeWithZoneCell dateTime={row.creationDateTime}
                                    timeZone={row.timeZone}
                                    className={classNames(styles.historyItemCell, 'd-flex')}/>
              <div className={styles.historyItemTypeCell}>{
                handleActionType(row)
              }</div>
              {isActionWaitingForDecision &&
              <ClickableActionText
                label={'order.details.history.actions.cargo.button'}
                onClick={() => onCargoApproveRejectClicked(row)}/>
              }
              {row.actionType === 'ORDER_STATUS_CHANGE' && isEditable &&
              <ClickableActionText
                label={'order.details.history.actions.edit'}
                onClick={() => onOrderStatusChangeEdit(row, index)}/>
              }
              {row.actionType === 'DELIVERY_POINT_CARGO_STATUS_CHANGE' &&
              <ClickableActionText
                label={'order.details.history.actions.show'}
                onClick={() => onDeliveryPointCargoShow(row)}/>
              }
              {row.actionType === 'EDIT' && row.versionBeforeEdit &&
              <ClickableActionText
                label={'order.details.history.actions.show'}
                onClick={() => showOrderEditHistory(row)}/>
              }
            </div>
          )
        })}
      </div>
    </RowsCollapse>
  )
}

function ClickableActionText ({ onClick, label }) {
  const { t } = useTranslation()
  return <Link onClick={onClick} title={t(label)} className="ml-2"/>
}
